import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";
import { supabase } from "./lib/supabase";
import "./app.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient, supabase },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Re-run route guards and invalidate session-dependent queries whenever
// Supabase auth state changes (sign-in, sign-out, token refresh). This is
// what makes the `_auth` layout redirect to /login on sign-out without a
// manual navigation.
supabase.auth.onAuthStateChange(() => {
  queryClient.invalidateQueries({ queryKey: ["session"] });
  void router.invalidate();
});

const container = document.getElementById("root");
if (!container) throw new Error("root container missing");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
